import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import CalendarAppResource from './CalendarAppResource';
import ChannelMemberAppResource from './ChannelMemberAppResource';
import ChannelPropertyInstanceAppResource from './ChannelPropertyInstanceAppResource';
import FileAppResource from './FileAppResource';
import MessageAppResource from './MessageAppResource';
import PropertyChannelAppResource from './PropertyChannelAppResource';
import StageAppResource from './StageAppResource';
import TaskAppResource from './TaskAppResource';
import WorkspaceAppResource from './WorkspaceAppResource';
import WorkspaceOrganizationMemberAppResource from './WorkspaceOrganizationMemberAppResource';
import PropertyInstanceAppResource from "./PropertyInstanceAppResource";

export const TYPE = {
    PRIVATE: 'private',
    PUBLIC: 'public',
}

class ChannelAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'channel';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'channels';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'archivedAt',
            'type',
            'workspaceUuid',
            'ownerWorkspaceOrganizationMemberUuid',
            'parentMessageUuid',
            'stageUuid',
            'isGeneral',
            'workspace',
            'ownerWorkspaceOrganizationMember',
            'parentMessage',
            'stage',
            'messages',
            'channelPropertyInstances',
            'members',
            'calendars',
            'propertyChannels',
            'files',
            'tasks',
            'ownerWorkspaceOrganizationMember',
            'filesMeta',
            'propertyInstanceUuid',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            workspace: WorkspaceAppResource,
            ownerWorkspaceOrganizationMember: WorkspaceOrganizationMemberAppResource,
            parentMessage: MessageAppResource,
            stage: StageAppResource,
            messages: MessageAppResource,
            channelPropertyInstances: ChannelPropertyInstanceAppResource,
            members: ChannelMemberAppResource,
            calendars: CalendarAppResource,
            propertyChannels: PropertyChannelAppResource,
            files: FileAppResource,
            tasks: TaskAppResource,
            propertyInstance: PropertyInstanceAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            workspace: 'workspace_uuid',
            ownerWorkspaceOrganizationMember: 'owner_workspace_organization_member_uuid',
            parentMessage: 'parent_message_uuid',
            stage: 'stage_uuid',
            propertyInstance: 'property_instance_uuid'
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            workspaceUuid: {
                type: 'string',
                presence: true,
            },
            workspace: {
                type: 'string',
            },
            ownerWorkspaceOrganizationMemberUuid: {
                type: 'string',
                presence: true,
            },
            ownerWorkspaceOrganizationMember: {
                type: 'string',
            },
            stageUuid: {
                type: 'string',
            },
            stage: {
                type: 'string',
            },
            type: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
                inclusion: [
                    'public',
                    'private',
                ],
            },
            parentMessageUuid: {
                type: 'string',
            },
            isGeneral: {
                type: 'boolean',
            },
            propertyInstanceUuid: {
                type: 'string',
            },
            files: {
                array: {
                    items: {
                        type: 'string',
                    },
                },
            },
            filesMeta: {
                array: {
                    items: {
                        array: {
                            items: {
                                type: 'string',
                            },
                        },
                    },
                },
            },
        };
    }

}

export default ChannelAppResource;
